export const featureSwitches = {
  viewCounter: 'enable_social_view_counter',
};
